import sdk from "../sdk";
import getAccessToken from "./getAccessToken";
import getSdkHost from "./getSdkHost";

export default function useCallSdk() {
  const callSdk = () =>
    sdk({
      apiHost: getSdkHost(),
      headers: { "x-access-token": getAccessToken() ?? "" },
    });

  return { callSdk };
}
